var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "maps" }, [
    _c(
      "div",
      { staticClass: "selected-provider" },
      [
        _c("p", { staticClass: "selected-provider__header" }, [
          _vm._v("Your Selected Location"),
        ]),
        _vm._v(" "),
        _c("provider", { attrs: { data: _vm.selectedMarker } }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "google-maps" }),
    _vm._v(" "),
    _c("div", { staticClass: "maps-hover" }, [
      _c(
        "div",
        { staticClass: "content" },
        [_c("provider", { attrs: { data: _vm.hoveredMarker } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }